import React, { lazy } from 'react';
import { type Route, type Routes } from 'react-resource-router';
import { InferredProjectsLoadingShell } from '../../pages/inferred-projects/components/LoadingStates';
import { componentWithSuspense } from '../../utils';
import { AppAccessGate } from '../AppAccessGate';

const InferredProjectsPage = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-inferred-projects" */ '../../pages/inferred-projects'
		),
);

const InferredProjectsRouteFallback = (): React.JSX.Element | null => (
	<InferredProjectsLoadingShell />
);

const InferredProjectsPageWithAccess: React.FC = () => {
	return (
		<AppAccessGate appName="Labs" fallback={<InferredProjectsLoadingShell />}>
			<InferredProjectsPage />
		</AppAccessGate>
	);
};

const ROUTE_PREFIX = '/inferred-projects' as const;

const inferredProjectsRoutesObject: Record<string, Route> = {
	home: {
		name: 'inferred-projects',
		path: ROUTE_PREFIX,
		exact: true,
		component: componentWithSuspense(
			InferredProjectsPageWithAccess,
			<InferredProjectsRouteFallback />,
		),
	},
};

export const inferredProjectsRoutes: Routes = Object.values(inferredProjectsRoutesObject);
